<span   class=' text-muted cursor-info badge badge-pill d-flex align-items-center justify-content-center mr-3 '>{{extractInitialsFromName(fullName)}}
</span>
